import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import { cleanObject } from 'marketplace-ui-common/utils/formatters';
export const assetDetailsResponseProviderDefaults = {
  name: '',
  avatarUrl: null,
  websiteUrl: '',
  description: '',
  location: null,
  certifications: []
};
export default class AssetProviderDetailsResponse extends createImmutableObjectClass(assetDetailsResponseProviderDefaults, {
  fromJSON: (_ref) => {
    let rest = Object.assign({}, _ref);
    return cleanObject(Object.assign({}, rest));
  },
  toJSON: (_ref2) => {
    let rest = Object.assign({}, _ref2);
    return Object.assign({}, rest);
  }
}) {}